import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_replenishment_event_filter_location_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_event_filter_location.model';

export class StockReplenishmentEventFilterLocationModel extends BaseContainerModel {
  bl_inv_stock_replenishment_event_filter_location: Bl_inv_stock_replenishment_event_filter_location_RowClass = new Bl_inv_stock_replenishment_event_filter_location_RowClass();
}
